import { environment } from 'src/environments/environment';
import { MARKET } from 'src/app/core/constants/market.constants';

import type { Market } from './market.util';

export type Auth0CustomerConfig = {
  clientId: string;
  externalUsersConnection: string;
};

export type Auth0StaffConfig = {
  clientId: string;
  internalUsersConnection: string;
};

/** Customer login — market-specific Auth0 SPA + SMS connection (AU vs NZ domain). */
export function getAuth0CustomerConfig(market: Market): Auth0CustomerConfig {
  return market === MARKET.NZ ? environment.auth0.nz : environment.auth0.au;
}

/** Staff (Azure) login — always `auth0-cnh` (AU Azure AD). ClientId comes from the domain SPA at call site. */
export function getAuth0StaffConfig(): Pick<Auth0StaffConfig, 'internalUsersConnection'> {
  return {
    internalUsersConnection: environment.auth0.au.internalUsersConnection,
  };
}

/** @deprecated Use {@link getAuth0CustomerConfig} for bootstrap / customer flows. */
export function getAuth0MarketConfig(market: Market): Auth0CustomerConfig {
  return getAuth0CustomerConfig(market);
}
